/**
 * FairwayBid – Helligkeit der Abschnittsbilder
 *
 * Über den Hintergrundbildern liegt eine dunkle Schicht ("Overlay"), damit
 * die weiße Schrift darauf lesbar bleibt. Wie dunkel, steht in der Console.
 * Für das große Bild der Startseite war sie zu dunkel – der Golfplatz war
 * kaum noch zu erkennen, und genau der soll dort zu sehen sein.
 *
 * Statt eines festen Werts steht hier ein Faktor. Er wirkt unabhängig davon,
 * welche Deckkraft in der Console eingestellt ist: 0.78 heißt "gut ein
 * Fünftel heller als eingestellt". Wer in der Console nachjustiert, bekommt
 * weiterhin das erwartete Verhalten, nur eben etwas heller.
 *
 * Die Schrift bleibt dabei lesbar, weil die Schicht nicht verschwindet –
 * sie wird nur dünner.
 */
export const OVERLAY_FAKTOR = {
  'public-start': 0.78,
};

/**
 * Gibt die Darstellung des Abschnitts zurueck – mit gedaempfter dunkler
 * Schicht, falls fuer diesen Abschnitt ein Faktor hinterlegt ist. Sonst
 * unveraendert.
 */
export const mitHelleremBild = (sectionId, appearance) => {
  const faktor = OVERLAY_FAKTOR[sectionId];
  const overlay = appearance?.backgroundImageOverlay;

  if (!faktor || typeof overlay?.opacity !== 'number') {
    return appearance;
  }

  return {
    ...appearance,
    backgroundImageOverlay: { ...overlay, opacity: overlay.opacity * faktor },
  };
};
